import React, { useEffect, useMemo } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { selectAccountConfig, selectUserConfig, selectIsLoading, selectActiveDisplay, selectDisplayStates } from '@selectors'

import Countdown from 'react-countdown'

import {
  SAFEWALK_UPDATE_STATE,
  SAFEWALK_ALERT_ACTION_SUBMIT,
  SAFEWALK_SET_DATA,
  UPDATE_LOADING
} from '@actions/types'

import dayjs from 'dayjs'

const SafeWalkTimer = () => {
  const dispatch = useDispatch()

  const accountConfig = useSelector(selectAccountConfig)
  const userConfig = useSelector(selectUserConfig)
  const loading = useSelector(selectIsLoading)
  const isSubmittingAlertAction = loading.some(({ loadingType }) => loadingType === SAFEWALK_ALERT_ACTION_SUBMIT)
  const activeDisplay = useSelector(selectActiveDisplay)
  const displayStates = useSelector(selectDisplayStates)

  const safewalkConfig = accountConfig?.safe_walk
  const dateCreated = userConfig?.safe_walk?.date_created
  const duration = userConfig?.safe_walk?.duration
  
  const activeState = activeDisplay?.state
  
  const hoursOfOperation = safewalkConfig?.hours_of_operation
  const { end_time: endTime, start_time: startTime } = hoursOfOperation

  const formatStartTime = dayjs().hour(startTime.hour).minute(startTime.min)
  const formatEndTime = dayjs().hour(endTime.hour).minute(endTime.min)
  const isOffHours = !dayjs().isBetween(formatStartTime, dayjs(formatEndTime), 'minutes')

  useEffect(() => {
    dispatch({
      type: SAFEWALK_SET_DATA,
      payload: { isOffHours }
    })
  }, [dispatch, isOffHours])

  const now = dayjs()
  const seconds = dateCreated?.seconds || 0

  const initialRemainingTime = useMemo(() => {
    const diff = now.diff(dayjs(seconds * 1000))
    const timeElapsed = dayjs.duration(diff).asMilliseconds()

    if (timeElapsed < 0) return 0

    return duration === 0 ? 0 : duration - timeElapsed
  }, [now, seconds, duration])

  const warningDuration = duration === 60000 ? 30000 : 90000

  const onHandleTick = ({ total }) => {
    if (isSubmittingAlertAction) return

    if (total === warningDuration && activeState === 'walk-activated') {
      dispatch({
        type: SAFEWALK_UPDATE_STATE,
        payload: {
          activeDisplay: displayStates.find(({ state }) => state === 'warning'),
          alarmTriggeredManually: false,
          nextState: 'warning'
        }
      })
    }

    if (total === 0 && activeState === 'warning') {
      dispatch({
        type: UPDATE_LOADING,
        payload: {
          loadingAction: 'set',
          meta: 'alarm-active'
        }
      })

      dispatch({
        type: SAFEWALK_UPDATE_STATE,
        payload: {
          activeDisplay: displayStates.find(({ state }) => state === 'alarm-active'),
          alarmTriggeredManually: false,
          nextState: 'alarm-active'
        }
      })
    }
  }

  return (
    <Countdown
      date={Date.now() + initialRemainingTime}
      daysInHours
      onTick={onHandleTick}
    />
  )
}

export default SafeWalkTimer
